import { useState, useEffect } from "react";

export default function useTheme() {
  const [theme, setTheme] = useState(
    () => localStorage.getItem("dash-theme") || "light"
  );

  useEffect(() => {
    document.documentElement.setAttribute("data-dash-theme", theme);
    localStorage.setItem("dash-theme", theme);
  }, [theme]);

  const toggle = () => setTheme((t) => (t === "light" ? "dark" : "light"));
  return { theme, toggle };
}
